export default __webpack_public_path__ + "static/nursing_carousel_1-49f987a9ea3e905f153afa9dd80e69bf.jpg";